<template>
  <div class="documentation-list-item-details">
    <DocumentationDescription v-if="description" :description="description" />

    <DocumentationAttachments
      v-if="hasAttachments"
      :attachment-groups="attachmentGroups"
      :legacy-attachments="legacyAttachments"
      :supplier-id="supplierId"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import type { ServiceOffer } from "@/custom-types/serviceOffers";
import DocumentationDescription from "./DocumentationDescription.vue";
import DocumentationAttachments from "./DocumentationAttachments.vue";

interface Props {
  description: string | null;
  attachmentGroups?: ServiceOffer["supplierRequestAttachmentGroups"];
  legacyAttachments?: ServiceOffer["supplierRequestAttachments"]; // For backward compatibility
  supplierId: number;
}

const props = defineProps<Props>();

const hasAttachments = computed(() => {
  if (props.attachmentGroups) {
    return props.attachmentGroups.some((group) => group.attachments.length > 0);
  }
  return (props.legacyAttachments?.length || 0) > 0;
});
</script>

<style lang="scss" scoped>
.documentation-list-item-details {
  border-top: 1px solid $color-border-light;
  padding-top: 1rem;
}
</style>
